/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { IHosportsDemoProductListViewProps } from '../../../modules/hosports-demo-product-list/./hosports-demo-product-list';
//@ts-ignore
import ProductTile from './../../../baseComponents/product-tile/./product-tile';
//@ts-ignore
import GridStructure from './../../../baseComponents/grid-structure/./grid-structure';
//@ts-ignore
import ScrollFadeIn from './../../../baseComponents/scroll-fade/./scroll-fade';
//@ts-ignore
import {GetProductsBySlugs} from './../utilities/dataFunctions';


interface IState {
  products?:any;
  outStockProds?:any;
  columns?:any;
}

class HosportsDemoProductList extends React.Component<IHosportsDemoProductListViewProps,IState> {

  public state: IState;
  constructor(props: IHosportsDemoProductListViewProps) {
    super(props);
    this.state = {
      products:null,
      columns:null
    };
  }

  public componentDidMount = async() => {
    const { config } = this.props;
    console.log(config)
    let inStockProducts : any = [];
    let outOfStockProducts : any = [];
    let products : any = [];
    if(config.products){
      for (let i = 0; i < config.products.length; i++) {
        if(config.products[i].inStock){
          inStockProducts.push(config.products[i].slug)
        } else{
          outOfStockProducts.push(config.products[i].slug)
        }
      }
      let inStockProds = await GetProductsBySlugs(inStockProducts);
      for (let index = 0; index < inStockProds.length; index++) {
        products.push({
          product:inStockProds[index],
          inStock:true
        })
      }
      let outStockProds = await GetProductsBySlugs(outOfStockProducts);
      for (let index = 0; index < outStockProds.length; index++) {
        products.push({
          product:outStockProds[index],
          inStock:false
        })
      }

      let columns : any = "4";
      if(config.columns){
        let columnDictinary : any = {
          two:"6",
          three:"4",
          four:"4",
          six:"2"
        }
        columns = columnDictinary[config.columns] ? columnDictinary[config.columns] : "4"

      }
      console.log(columns)
      this.setState({
        columns:columns,
        products:products
      })
    }
  }
  public render(): JSX.Element {
    return (
      <div className="site-gutter hosports-demo-product-list">
        <div>
          {this.state.columns &&
            <GridStructure
              columns={this.state.columns}>
                {this.state.products && this.state.products.map((item:any) =>{
                  if(item.inStock){
                    return(
                      <ScrollFadeIn><a href={'/demoForm?id='+item.product.attributes.slug}><div className="enabled-product"><ProductTile product={item.product} /></div></a></ScrollFadeIn>
                    )
                  } else{
                    return(
                      <ScrollFadeIn><div className="disabled-product"><ProductTile product={item.product} /><h5 className="disabled-product-status">{'Out of Stock'}</h5></div></ScrollFadeIn>
                    )
                  }
                })}
              </GridStructure>
          }
        </div>
      </div>
    );
  }
};

export default HosportsDemoProductList;
